
(function(){
  const cfg=window.vikarShopify||{};
  const assets=cfg.assets||{};
  const productUrls=cfg.productUrls||{};
  const productKeyByFile={
    'product-graceful.html':'graceful','product-powerful.html':'powerful','product-rare.html':'rare','product-timeless.html':'timeless','product-worthy.html':'worthy','product-unstoppable.html':'unstoppable',
    'product-glowup.html':'glowup','product-goldenhour.html':'goldenhour','product-rosebloom.html':'rosebloom','product-sunkiss.html':'sunkiss','product-coralbliss.html':'coralbliss','product-era-bundle.html':'bundle',
    'product-lipstick-pack-2.html':'lipstickpack2','product-blush-pack-2.html':'blushpack2'
  };
  window.vikarResolveAsset=function(src){
    if(!src || typeof src!=='string') return src;
    const clean=src.replace(/^\/?/,'').replace(/\?v=\d+$/,'');
    return assets[clean] || assets[src] || src;
  };
  window.vikarProductUrlFor=function(path){
    if(!path || typeof path!=='string') return path;
    const file=path.split('/').pop();
    const map={
      'product-graceful.html':productUrls.graceful,'product-powerful.html':productUrls.powerful,'product-rare.html':productUrls.rare,'product-timeless.html':productUrls.timeless,'product-worthy.html':productUrls.worthy,'product-unstoppable.html':productUrls.unstoppable,
      'product-glowup.html':productUrls.glowup,'product-goldenhour.html':productUrls.goldenhour,'product-rosebloom.html':productUrls.rosebloom,'product-sunkiss.html':productUrls.sunkiss,'product-coralbliss.html':productUrls.coralbliss,'product-era-bundle.html':productUrls.bundle,
      'product-lipstick-pack-2.html':productUrls.lipstickpack2,'product-blush-pack-2.html':productUrls.blushpack2,
      'index.html':cfg.routes?.rootUrl || '/','shop.html':cfg.routes?.allProductsUrl || '/collections/all?view=shop','about.html':cfg.routes?.aboutUrl || '/collections/all?view=about','press.html':cfg.routes?.pressUrl || '/collections/all?view=press','contact.html':cfg.routes?.contactUrl || '/collections/all?view=contact','faqs.html':cfg.routes?.faqsUrl || '/collections/all?view=faqs',
      'privacy-policy.html':cfg.routes?.privacyUrl || '/collections/all?view=privacy-policy','shipping-policy.html':cfg.routes?.shippingUrl || '/collections/all?view=shipping-policy','returns-exchange.html':cfg.routes?.returnsUrl || '/collections/all?view=returns-exchange','terms-of-service.html':cfg.routes?.termsUrl || '/collections/all?view=terms-of-service','contact-information.html':cfg.routes?.contactInformationUrl || '/collections/all?view=contact-information'
    };
    return map[file] || path;
  };
  function rewrite(root=document){
    root.querySelectorAll?.('a[href$=".html"]').forEach(link=>{
      const raw=link.getAttribute('href');
      const file=raw?.split('/').pop();
      const key=productKeyByFile[file];
      if(key) link.setAttribute('data-vikar-product-link',key);
      const destination=window.vikarProductUrlFor(raw);
      if(destination&&destination!==raw) link.setAttribute('href',destination);
    });
    root.querySelectorAll?.('[data-vikar-product-link]').forEach(link=>{
      const key=link.getAttribute('data-vikar-product-link');
      const destination=productUrls[key];
      if(destination&&link.getAttribute('href')!==destination) link.setAttribute('href',destination);
    });
    root.querySelectorAll?.('img').forEach(img=>{
      const raw=img.getAttribute('src');
      if(raw && raw.startsWith('assets/')){
        img.setAttribute('data-vikar-src',raw);
        img.setAttribute('src',window.vikarResolveAsset(raw));
      }
    });
  }
  rewrite();
  new MutationObserver(mutations=>{
    mutations.forEach(m=>{
      if(m.type==='childList') m.addedNodes.forEach(node=>{if(node.nodeType===1) rewrite(node)});
      if(m.type==='attributes' && m.target.nodeType===1) rewrite(m.target.parentElement||document);
    });
  }).observe(document.documentElement,{subtree:true,childList:true,attributes:true,attributeFilter:['src','href']});
  document.addEventListener('DOMContentLoaded',()=>{
    document.querySelectorAll('.product-card').forEach(card=>{
      if(card.dataset.vikarBound) return;
      card.dataset.vikarBound='true';
      let timer;
      card.addEventListener('pointerenter',()=>{clearTimeout(timer);timer=setTimeout(()=>card.classList.add('flip-ready'),90)});
      card.addEventListener('pointerleave',()=>{clearTimeout(timer);card.classList.remove('flip-ready','no-click-flip')});
      card.addEventListener('pointerdown',()=>{clearTimeout(timer);card.classList.remove('flip-ready');card.classList.add('no-click-flip')});
      card.addEventListener('click',event=>{if(event.target.closest('a,button,input,select')) return; const url=card.dataset.productUrl; if(url) window.location.href=url});
    });
  });
})();
